import { ApiClient } from "@/services/ApiService";

export default {
  async deleteTest(id) {
    const response = await ApiClient.delete(`test/${id}`);
    return response.data;
  },
  async getTests() {
    const response = await ApiClient.get(`test`);
    return response.data;
  },
  async getTest(id) {
    const response = await ApiClient.get(`test/${id}`);
    return response.data;
  },
  async getTestsByLocationId(id) {
    const response = await ApiClient.get(`test/location/${id}`);
    return response.data;
  },
  async postTest(test) {
    const response = await ApiClient.post(`test`, test);
    return response.data;
  },
  async putTest(test) {
    const response = await ApiClient.put(`test/${test.testId}`, test);
    return response.data;
  },
  async getThumbnail(id) {
    const response = await ApiClient.get(`test/thumbnail/${id}`);
    return response.data;
  },
  async postThumbnail(thumbnail, id) {
    const response = await ApiClient.post(`test/thumbnail?id=${id}`, thumbnail);
    return response.data;
  },
  async getDocs(id) {
    const response = await ApiClient.get(`test/docs/${id}`);
    return response.data;
  },
  async postDocs(docs, id) {
    const response = await ApiClient.post(`test/docs?id=${id}`, docs);
    return response.data;
  },
  async getVideo(id) {
    const response = await ApiClient.get(`test/video/${id}`);
    return response.data;
  },
  async postVideo(video, id) {
    const response = await ApiClient.post(`test/video/${id}`, video);
    return response.data;
  }
};
